import { UserInfo } from "../models/User";
import { post } from "../utils/backend";
import { getMockData, mock } from "./mock/Mock";

interface CurrentUser {
    token: string;
    userProps: Record<string, any>;  // Map<String, Object> 转为 Record<string, any>
    loginUrl: string;
}

// 获取用户信息
const getUserByToken = async (): Promise<UserInfo | null> => {
    if (mock&&false) {
        return getMockData("getUserByToken");
    }
    const resultOrErrorCode = await post<null, CurrentUser>("/user/getUserInfo", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return null;
    }
    if (!resultOrErrorCode) {
        return null;
    }
    return convertToUserInfo(resultOrErrorCode);
};

// 转换函数
function convertToUserInfo(currentUser: CurrentUser): UserInfo {
    // 初始化 UserInfo 对象
    const userInfo: UserInfo = {
        nickname: currentUser.userProps.name,
        phone: currentUser.userProps.phone, 
        token: currentUser.token, 
    }; 
    return userInfo;
}

// 用户登录
const loginApi = async (phoneNo: string, passwordMd5: string): Promise<UserInfo | null> => {
    if (mock&&false) {
        return getMockData("login");
    }
    const resultOrErrorCode = await post<{ phoneNo: string; passwordMd5: string }, CurrentUser>("/user/login", { phoneNo, passwordMd5 });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return null;
    }
    if (!resultOrErrorCode.token) {
        return null;
    }
    localStorage.setItem("token", resultOrErrorCode.token);
    return convertToUserInfo(resultOrErrorCode);
};

// 用户登出
const logoutApi = async (): Promise<void> => {
    if (mock) {
        return;
    }
    const resultOrErrorCode = await post<{}, boolean>("/user/logout", {});
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return;
    }
};

// 更新用户信息
export type UpdateUserFields = { nickname?: string; password?: string; address?: string; recipientName?: string };

const updateUserInfo = async (phone: string, fields: UpdateUserFields): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ phone: string } & UpdateUserFields, boolean>("/user/updateUserInfo", { phone, ...fields });
    if (typeof resultOrErrorCode === 'string') {
        return false;
    }
    return !!resultOrErrorCode;
};

export const UserApi = {
    getUserByToken,
    loginApi,
    logoutApi,
    updateUserInfo
};